const API_BASE_URL =
  process.env.NEXT_PUBLIC_API_URL || "https://www.lilylanka.com";

export interface HotelRateSettingsResponse {
  result: {
    hotel_Id: number;
    discount_Offers: number;
    default_Genius_Discount: number;
    service_Charge: number;
    vat: number;
    city_Tax: number;
    commission: number;
    ipg_Rate: number;
    other_Rate1: number;
    other_Rate2: number;
    status: number;
    roomRateAmount: number;
    discountOffersAmount: number;
    defaultGeniusDiscountAmount: number;
    grossAmount: number;
    serviceChargeAmount: number;
    totalForVatAmount: number;
    vatAmount: number;
    cityTaxAmount: number;
    ssclAmount: number;
    finalPriceShownToGuestAmount: number;
    commissionIncomeAmount: number;
    bankChargesAmount: number;
    cancellationChargesAmount: number;
    netPayToHotelAmount: number;
    hotelBankChargesBearerAmount: number;
    lillyBankChargesBearerAmount: number;
    incomeLillyAmount1: number;
    incomeLillyAmount2: number;
  };
  message: string;
  errors: string[];
  id: number;
}

export async function fetchHotelRateSettings(
  hotelId: number,
  baseValue: number,
): Promise<HotelRateSettingsResponse> {
  const response = await fetch(
    `${API_BASE_URL}/api/HotelRateSettings/hotel/${hotelId}/base_value/${baseValue}`,
    {
      method: "GET",
      headers: {
        accept: "application/json",
      },
    },
  );

  if (!response.ok) {
    throw new Error("Failed to fetch hotel rate settings");
  }

  return response.json();
}
